import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { Field, FieldProps } from "formik";
import { ComponentProps } from "react";

type CheckboxFieldProps = {
  checkboxProps: Omit<
    ComponentProps<typeof Checkbox>,
    "value" | "onChange" | "name" | "onBlur" | "checked"
  >;
  name: string;
};

export const CheckboxField = ({
  checkboxProps,
  ...props
}: CheckboxFieldProps) => {
  return (
    <Field {...props}>
      {({ field }: FieldProps) => {
        return (
          <Checkbox
            {...field}
            {...(checkboxProps || {})}
            checked={field.value}
          />
        );
      }}
    </Field>
  );
};
